import { type Section } from '../../restapi/types';
import { cleanConfidential } from '../../restapi/utils';


interface Props {
	section: Section;
}

export function PreviewSection({section: s}: Props) {
	const content = cleanConfidential(s.content);
	return (
		<div dangerouslySetInnerHTML={{__html: content}}/>
	);
}
